











export default {
  name: 'origins-landing',
  props: {
    messages: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      scrollImageUrl: require('../../../assets/media/image/scroll.gif')
    };
  }
};

